import React, { JSX } from 'react';
import { DatePickerElement, FormConfig } from '../types/types';
import FormDatePicker from './FormDatePicker';

interface Props {
  config: DatePickerElement;
  keySuffix?: FormConfig['keySuffix'];
}

const DatePickerWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      key,
      label,
      boldLabel,
      placeholder,
      showErrorIcon,
      icon,
      disabled,
      withKeyboardSupport,
      showInModal,
      displayFormat,
      minDate,
      maxDate,
      inputClassName,
      useFormValidation,
      setValueToNullWhenFormatIsIncorrect,
      modalLabel,
      noInitialValueInput,
      validateOnBlurOnly,
      showSuccessState
    },
    keySuffix
  } = props;

  return (
    <FormDatePicker
      name={`${key}${keySuffix || ''}`}
      label={label}
      boldLabel={boldLabel}
      showErrors
      dataTestId=""
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      placeholderText={placeholder}
      showErrorIcon={showErrorIcon}
      icon={icon}
      disabled={disabled}
      withKeyboardSupport={withKeyboardSupport}
      showInModal={showInModal}
      displayFormat={displayFormat}
      minDate={minDate}
      maxDate={maxDate}
      inputClassName={inputClassName}
      useFormValidation={useFormValidation}
      setValueToNullWhenFormatIsIncorrect={setValueToNullWhenFormatIsIncorrect}
      modalLabel={modalLabel}
      noInitialValueInput={noInitialValueInput}
      validateOnBlurOnly={validateOnBlurOnly}
      showSuccessState={showSuccessState}
    />
  );
};

export default DatePickerWrapper;
